export default function User (props) {
  const self = {
    get username() {
      return props.username || props.id || props.email
    },
    get first_name() {
      return props.first_name
    },
    get last_name() {
      return props.last_name
    },
    is: (identifier) => {
      return props.username == identifier || props.id == identifier || props.email == identifier
    }
  }

  return Object.assign({}, props, self)
}
